import {BatchAcknowledgementElementDto, Links} from '../services/generated';

export class BatchAcknowledgementElementModel implements BatchAcknowledgementElementDto {
  public id: number;
  public databaseElementId: number;
  public title: string | null;
  public link: Array<Links> | null;
  public isProcess: boolean;
  public documentId: string | null;
  public languageCode: string | null;
  public relativeUrl: string | null;
  public opened: boolean;
  public confirmed: boolean;
  public get typeString() {
    return this.isProcess ? 'Process' : 'Document';
  }
  constructor(batch: BatchAcknowledgementElementDto) {
    this.id = batch.id;
    this.databaseElementId = batch.databaseElementId;
    this.title = batch.title;
    this.isProcess = batch.isProcess;
    this.documentId = batch.documentId;
    this.languageCode = batch.languageCode;
    this.relativeUrl = batch.relativeUrl;
    this.opened = batch.opened;
    this.confirmed = batch.confirmed;
    this.link = batch.link;
  }
}
